import type { ListRowsValueProps } from 'entities/history';

export function ListRows({ data }: ListRowsValueProps) {
  return (
    <div>
      {data.map((value, index) => (
        <div
          className="flex w-[335px] items-center border-b border-slate-100 py-2 text-[13px] last:border-0"
          key={`${value}-${index}`}
        >
          {value}
        </div>
      ))}
    </div>
  );
}
